import { z } from 'zod';
import { UserUpdateParameters } from '@mews-commander/data-access';
import {
    createZodFormResolver,
    DateTimeLocalizationInfo,
    useDateTimeLocalizationInfo,
    useFormControls,
    Validation,
} from '@mews/framework';
import { createUpdateValueObject } from '@mews-commander/utils';
import { ProfileFormValues } from './types';

const createProfileFormResolver = (dateTimeLocalizationInfo: DateTimeLocalizationInfo) =>
    createZodFormResolver<Partial<ProfileFormValues>>(
        z.object({
            firstName: Validation.String.Required,
            lastName: Validation.String.Required,
            primaryMailAddress: Validation.String.Required,
            userId: Validation.String.Required,
            birthDate: z.nullable(Validation.BirthDate.Iso(dateTimeLocalizationInfo)),
        })
    );

export const useProfileForm = ({
    defaultValues,
    onSubmit,
}: {
    defaultValues: ProfileFormValues;
    onSubmit: (params: UserUpdateParameters) => void;
}) => {
    const dateTimeLocalizationInfo = useDateTimeLocalizationInfo();

    const { renderFormContent, submit } = useFormControls<ProfileFormValues>({
        defaultValues,
        mode: 'onBlur',
        resolver: createProfileFormResolver(dateTimeLocalizationInfo),
        onSubmit: (values) => {
            const updatedValues = createUpdateValueObject({ ...defaultValues }, { ...values });

            if (Object.keys(updatedValues).length > 0) {
                onSubmit(updatedValues);
            }
        },
        shouldFocusError: true,
    });

    return {
        submit,
        renderFormContent,
    };
};
